export { default } from './PaymentIcons';
